module.exports = __webpack_public_path__ + "img/Antargaz_80X30.3fe161ee.png";